export default "__VITE_ASSET__D_Y1qyhY__"